import { required } from './required';
export function integer(value) {
    return value !== '' && value != null && !/^[0-9]+$/.test(value)
        ? 'Enter a whole number'
        : '';
}
export var requiredInteger = required(integer);
//# sourceMappingURL=integer.js.map